<template>
  <div class="content_box">
    <div class="logManage" id="ManageTable">
      <div class="userManage_header">
        <div class="userManage_logo">
          <img src="@/assets/imgs/icon/log_logo.png" alt />
        </div>
        <h3>日志操作</h3>
      </div>
      <!-- <div class="userManage_form"> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="操作用户">
          <el-input
            v-model.trim="formInline.operationUser"
            placeholder="请输入用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务模块">
          <el-select v-model="formInline.businessModule" placeholder="不限">
            <el-option label="不限" value></el-option>
            <el-option label="企业库" value="企业库"></el-option>
            <el-option label="园区库" value="园区库"></el-option>
            <el-option label="项目库" value="项目库"></el-option>
            <el-option label="数据填报" value="数据填报"></el-option>
            <el-option label="数据导入" value="数据导入"></el-option>
            <el-option label="数据代填" value="数据代填"></el-option>
            <!-- <el-option label="申请修改" value="申请修改"></el-option>
          <el-option label="报表审核" value="报表审核"></el-option>-->
          </el-select>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="formInline.operationType" placeholder="不限">
            <el-option label="不限" value></el-option>
            <el-option label="新增" value="新增"></el-option>
            <el-option label="删除" value="删除"></el-option>
            <el-option label="编辑" value="编辑"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker
            v-model="formInline.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <!-- </div> -->
      <hr />
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column
          align="center"
          type="index"
          width="100"
          label="序号"
        ></el-table-column>
        <el-table-column
          prop="businessModule"
          label="业务模块"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span class="detail" @click="handleDetail(scope.row)">{{
              scope.row.businessModule
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operationType"
          label="操作类型"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operationUser"
          label="操作用户"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ip"
          label="登录IP"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="operationTime"
          label="操作时间"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleDetail(scope.$index, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="查看"
        :visible.sync="detailDialogVisible"
        class="dialog68 titleChange bodyScroll"
        :close-on-click-modal="false"
      >
        <div class="addUser">{{ modifyContent }}</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detailDialogVisible: false, //查看日志
      currentPage: 1,
      pageNum: 1,
      total: 0,
      modifyContent: "",
      loading: false,
      formInline: {
        operationUser: "",
        businessModule: "",
        operationType: "",
        time: "",
      },
      tableData: [],
    };
  },
  created() {
    this.getData(this.pageNum);
  },
  methods: {
    getData(pageNum) {
      this.loading = true;
      this.$axios
        .get("/system/log/list", {
          params: {
            pageNum,
            pageSize: 10,
            operationUser: this.formInline.operationUser,
            businessModule: this.formInline.businessModule,
            operationType: this.formInline.operationType,
            time:
              this.formInline.time == ""
                ? ""
                : this.formInline.time[0] + "-" + this.formInline.time[1],
          },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    onSubmit() {
      //查询
      this.$axios
        .get("/system/log/list", {
          params: {
            pageNum: this.pageNum,
            pageSize: 10,
            operationUser: this.formInline.operationUser,
            businessModule: this.formInline.businessModule,
            operationType: this.formInline.operationType,
            time:
              this.formInline.time == ""
                ? ""
                : this.formInline.time[0] + "-" + this.formInline.time[1],
          },
        })
        .then((res) => {
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reset() {
      //重置
      // console.log("onReset");
      for (const key in this.formInline) {
        this.formInline[key] = "";
      }
      this.pageNum = 1;
      this.getData(this.pageNum);
      this.currentPage = 1;
    },
    handleDetail(index, row) {
      //查看
      console.log(index, row);
      this.detailDialogVisible = true;
      this.$axios
        .get("/system/log/selectOne", {
          params: {
            id: row.id,
          },
        })
        .then((res) => {
          this.modifyContent = res.data.modifyContent;
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //跳转页
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getData(val);
    },
  },
};
</script>
 <style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.logManage {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .userManage_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .userManage_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  hr {
    border-color: rgba(155, 155, 155, 0.2);
    margin: 10px 0 20px;
  }
  .userManage_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 29px;
      }
    }
  }
}
.addUser {
  width: 100%;
  height: 100%;
}
</style>